import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import colors from '../theme/colors';

const NotFoundContainer = styled.div`
  min-height: calc(100vh - 200px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: ${colors.lightGray};
`;

const NotFoundContent = styled.div`
  text-align: center;
  max-width: 600px;
`;

const NotFoundCode = styled.h1`
  font-size: 8rem;
  font-weight: 900;
  margin: 0;
  background: ${colors.mainGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 5rem;
  }
`;

const NotFoundTitle = styled.h2`
  font-size: 2rem;
  margin: 1rem 0;
  color: ${colors.mainBlack};
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const NotFoundMessage = styled.p`
  font-size: 1.1rem;
  color: ${colors.textGray};
  margin-bottom: 2rem;
  line-height: 1.6;
`;

const NotFoundActions = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const HomeButton = styled(Link)`
  background: ${colors.mainGradient};
  color: ${colors.mainWhite};
  padding: 0.8rem 2rem;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 2px 4px rgba(255, 86, 30, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(255, 86, 30, 0.4);
    color: ${colors.mainWhite};
    text-decoration: none;
  }
`;

const BackButton = styled.button`
  background: transparent;
  color: ${colors.mainOrange};
  padding: 0.8rem 2rem;
  border: 2px solid ${colors.mainOrange};
  border-radius: 4px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${colors.mainOrange};
    color: ${colors.mainWhite};
  }
`;

const NotFound: React.FC = () => {
  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <NotFoundContainer>
      <NotFoundContent>
        <NotFoundCode>404</NotFoundCode>
        <NotFoundTitle>Сторінку не знайдено</NotFoundTitle>
        <NotFoundMessage>
          Вибачте, але сторінка, яку ви шукаєте, не існує або була переміщена.
          <br />
          Перевірте правильність URL або поверніться на головну сторінку.
        </NotFoundMessage>
        <NotFoundActions>
          <HomeButton to="/">На головну</HomeButton>
          <BackButton onClick={handleGoBack}>Назад</BackButton>
        </NotFoundActions>
      </NotFoundContent>
    </NotFoundContainer>
  );
};

export default NotFound;



